import { addDoc, collection, doc, serverTimestamp, updateDoc } from "firebase/firestore";
import { db } from "../../../firebase/config";
import { message } from "antd";

export const UpdateSplitOrder = async (orderData, rollsCreated, rollsRemaining, comment, user, setOpenSecond) => {
  //old order object
  const oldOrderObject = orderData;

  //creates aa copy without the id
  const { id, ...copyOfOrder } = oldOrderObject;

  //old order ref
  const oldOrderRef = doc(db, "orders", oldOrderObject.id);

  //new order object
  const newOrderObject = {
    ...copyOfOrder,
    rollCount: rollsCreated,
    splitTime: serverTimestamp(),
    splitOrder: true,
    otherOrderId: oldOrderObject.id,
    tapeComment: comment,
    tapePrinter: user.uid,
    tapePrinterEmail: user.email,
    beforeSplitRolls: oldOrderObject.rollCount,
    partOfSplit: 2,
    totalParts: 2,
  };

  // orderStatus: 6,
  // hasRoll: false,

  //ref for the new order
  const newDocRef = collection(db, "orders");

  try {
    //creates a new doc with same params
    await addDoc(newDocRef, newOrderObject);

    //updates the old order
    await updateDoc(oldOrderRef, {
      splitTime: serverTimestamp(),
      splitOrder: true,
      rollCount: rollsRemaining,
      otherOrderId: newDocRef.id,
      beforeSplitRolls: oldOrderObject.rollCount,
      partOfSplit: 1,
      totalParts: 2,
    });
  } catch (error) {
    message.error("Error happened! Check logs");
    console.log(error.message);
  } finally {
    message.success("Order split!");
    setOpenSecond(false);
  }
};
